import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import {
  clearPersistedClusterDraft,
  getPersistedStorageKeyForCreatePath,
  isCreateClusterPath
} from "@/utils/cluster";

/**
 * Clears create-cluster localStorage drafts when the user SPA-navigates away from a
 * create page. Does nothing on full refresh / hard navigations (e.g. OAuth), so those
 * can still restore via sessionStorage + localStorage.
 *
 * Must live in a component that stays mounted across route changes (e.g. App).
 */
export function useClearClusterDraftOnNavigateAway() {
  const [location] = useLocation();
  const prevLocationRef = useRef(location);

  useEffect(() => {
    const prevPath = prevLocationRef.current.split("?")[0];
    const nextPath = location.split("?")[0];
    prevLocationRef.current = location;

    if (!isCreateClusterPath(prevPath) || prevPath === nextPath) {
      return;
    }

    const storageKey = getPersistedStorageKeyForCreatePath(prevPath);
    if (storageKey) {
      clearPersistedClusterDraft(storageKey);
    }
  }, [location]);
}
